module.exports = __webpack_public_path__ + "img/image-not-found.2e31e824.png";